import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { changePasswordRequest } from "../../../../Backend/UsersRequests";
import { ErrorLevels, Roles, WebRoutes } from "../../../../Constants";
import { hasValue } from "../../../../Helpers/validations/common";
import { setToastText } from "../../../../Reducer";
import { FormInput } from "../../../../Components";
import "./ChangePassword.scss";

export function ChangePassword() {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.credentials);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    if (
      hasValue(oldPassword) &&
      hasValue(newPassword) &&
      hasValue(repeatNewPassword) &&
      repeatNewPassword === newPassword
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [oldPassword, newPassword, repeatNewPassword]);

  const redirect = () => {
    if (userData) {
      switch (userData.role) {
        case Roles.Admin:
          navigate(WebRoutes.UserHomePage);
          break;

        case Roles.SchoolManager:
          navigate(WebRoutes.SchoolHomePage);
          break;

        default:
          navigate(-1);

          break;
      }
    } else {
      navigate(-1);
    }
  };

  const changePassword = async () => {
    setPasswordError(t(""));
    if (checkNewPasswordPolicy()) {
      setButtonDisabled(true);

      const resp = await changePasswordRequest({
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: repeatNewPassword,
      });

      if (resp.success) {
        dispatch(
          setToastText({
            text: t("PasswordChangedSuccess"),
            level: ErrorLevels.Success,
          })
        );

        setTimeout(() => {
          redirect();
        }, 3000);
      } else {
        setPasswordError(t(resp.errors[0].errorMessageKey));
        dispatch(
          setToastText({
            text: t("PasswordChangedError"),
            level: ErrorLevels.Error,
          })
        );
      }
    } else {
      setPasswordError(t("PasswordPolicyIncorrect"));
    }
  };

  const checkNewPasswordPolicy = () => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]{8,}$/;
    return regex.test(newPassword);
  };

  return (
    <div className="change-password-page">
      <div className="header">
        <div className="title">{t("ChangePasswordTitle")}</div>
        <div className="description">{t("ChangePasswordDescription")}</div>
      </div>
      <div className="block-wrapper">
        <div className="block-info">
          <div className="input-wrapper">
            <span className="label">{t("OldPassword")}</span>
            <FormInput
              placeholder=""
              visibilityPassword={true}
              type={"password"}
              value={oldPassword}
              change={(x) => {
                setOldPassword(x);
              }}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("NewPassword")}</span>
            <FormInput
              placeholder=""
              visibilityPassword={true}
              type={"password"}
              value={newPassword}
              errorText={t("PasswordsNotMatch")}
              error={
                hasValue(newPassword) &&
                hasValue(repeatNewPassword) &&
                newPassword !== repeatNewPassword
              }
              change={(x) => {
                setNewPassword(x);
              }}
            />
          </div>
          <div className="input-wrapper">
            <span className="label">{t("RepeatNewPassword")}</span>
            <FormInput
              placeholder=""
              visibilityPassword={true}
              type={"password"}
              value={repeatNewPassword}
              errorText={t("PasswordsNotMatch")}
              error={
                hasValue(newPassword) &&
                hasValue(repeatNewPassword) &&
                newPassword !== repeatNewPassword
              }
              change={(x) => {
                setRepeatNewPassword(x);
              }}
            />
          </div>
        </div>

        {hasValue(passwordError) && (
          <div className="password-error-wrapper">{passwordError}</div>
        )}

        <div className="button-wrapper">
          <Button
            className="button"
            disabled={buttonDisabled}
            onClick={() => changePassword()}
          >
            {t("ChangePassword")}
          </Button>
        </div>
      </div>
    </div>
  );
}
